import { I18nModel } from '@bingads-webui/copilot-i18n';
import { type SummarizePluginResult } from '../../types';

export function getComparisonDatePeriod({ i18n, summarizePluginResult }: { i18n:I18nModel, summarizePluginResult?: SummarizePluginResult }) {
  const options = { date: 'long', timeZone: 'UTC' };
  const result = summarizePluginResult?.Result;

  const startDate = i18n.formatDate(new Date(result?.startDate), options);
  const endDate = i18n.formatDate(new Date(result?.endDate), options);
  const comparisonStartDate = i18n.formatDate(new Date(result?.comparisonStartDate), options);
  const comparisonEndDate = i18n.formatDate(new Date(result?.comparisonEndDate), options);

  return i18n.getString(
    _TL_('{{startDate}} - {{endDate}} [compared to {{comparisonStartDate}} - {{comparisonEndDate}}]'),
    {
      startDate, endDate, comparisonStartDate, comparisonEndDate,
    },
  );
}
